/** When true, checkout skips Clover and confirms orders at $0 (local/staging tests only). */
export const CHECKOUT_ZERO_TEST =
  import.meta.env.VITE_CHECKOUT_ZERO_TEST === '1' ||
  import.meta.env.VITE_CHECKOUT_ZERO_TEST === 'true';

export const ZERO_TEST_CHARGE = {
  chargeId: 'zero-test',
  amount: 0,
  status: 'succeeded',
  paid: true,
} as const;
